import React, {useCallback} from 'react';
import {TruvuTextField} from '../../../../components/textField';
import {Form, FormOnSubmit} from '../../../../components/form/Form';
import {TruvuButton} from '../../../../components/button/TruvuButton';
import {useTourLeadsCapture} from '../hooks/useTourLeadsCapture';
import TurnstileWidget from '../../../signup/components/TurnstileWidget';
import * as yup from 'yup';
import {PhoneNumberFormikField} from '../../../../components/textField/PhoneNumberTextfield';

interface Values {
  name: string;
  surname?: string;
  email: string;
  turnstileToken: string;
  contactNumber?: string;
}

const initialValues: Values = {
  name: '',
  email: '',
  turnstileToken: '',
};

const validationSchema: yup.SchemaOf<Values> = yup.object({
  email: yup
    .string()
    .trim()
    .email('Not a valid email.')
    .required('Email is a required field.'),
  name: yup.string().required('Name is a required field.'),
  surname: yup.string(),
  contactNumber: yup.string(),
  turnstileToken: yup.string().required(),
});

interface TourPreviewLeadCaptureProps {
  tourId: string;
  onCancel: () => void;
  onComplete: () => void;
}

export function TourPreviewLeadCapture({
  tourId,
  onCancel,
  onComplete,
}: TourPreviewLeadCaptureProps) {
  const [tourLeadCreate] = useTourLeadsCapture();
  const onSubmit = useCallback<FormOnSubmit<Values>>(
    async (values, formikHelpers) => {
      formikHelpers.setSubmitting(true);
      try {
        await tourLeadCreate({
          variables: {
            input: {
              ...values,
              leadType: 'LIVE_VIEWING',
              tourId,
            },
          },
          onCompleted: (response) => {
            localStorage.setItem(
              'capturedDetails',
              JSON.stringify(response.tourLeadCreate.tourLead)
            );
            onComplete();
          },
        });
      } finally {
        formikHelpers.setSubmitting(false);
      }
    },
    [onComplete, tourId, tourLeadCreate]
  );
  return (
    <>
      <Form
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={onSubmit}
      >
        <TruvuTextField name="name" label="Name" formikField />
        <TruvuTextField name="surname" label="Surname" formikField />
        <TruvuTextField name="email" label="Email" formikField />
        <PhoneNumberFormikField name="contactNumber" label="Contact Number" />
        <TurnstileWidget />
        <TruvuButton sx={{mt: 2}} formikSubmit>
          Submit
        </TruvuButton>
        <TruvuButton variant="secondary" onClick={onCancel}>
          Cancel
        </TruvuButton>
      </Form>
    </>
  );
}
